import { AssetDetails } from '../types/interfaces';
import { ReportDataResponse } from '../types/reportData.interface';
import {
  ValuationDataModel,
  RentProfile,
  SaleProfile,
} from '../types/valuation.interface';
import { AssetProfileDataModel } from '../types/assetProfile.interface';

/**
 * Mock data for developing and testing the asset report layout
 * without API connection. Use route /asset/sheet-dev.
 */

export const mockAssetDetails: AssetDetails = {
  listingType: 1,
  operation: 0,
  lat: 40.4168,
  lon: -3.7038,
  address: 'Calle Gran Vía 1, 28013 Madrid',
  area: 100,
  reportType: 2,
  pulseType: 1,
  rooms: 3,
  nbaths: 2,
  floor: 2,
  propertyType: 4,
  buildStatus: 1,
  yearBuilt: 2010,
  estimatedPrice: 1457,
  estimatedPriceSqm: 10,
  estimatedMin: 950,
  estimatedMax: 2400,
  yield: 4.5,
  rentValue: 1457,
  saleValue: 561933,
};

export const mockReportData: ReportDataResponse = {
  id: 1,
  company_id: 1,
  name: 'Estilo desarrollo',
  logo: null,
  company: 'Nombre empresa',
  address: 'Calle ejemplo 123',
  city: 'Madrid',
  fullname: 'Contacto desarrollo',
  phone: '+34 600 000 000',
  email: 'info@empresa.com',
  description: null,
  image: '',
  exclude_rent: false,
  exclude_sale: false,
  is_private: false,
  pulse_type: 1,
  reportType: 2,
};

const mockRentProfile: RentProfile = {
  bestMethod: 'ECO',
  mainValue: 1457,
  estimatedMin: 950,
  estimatedMax: 2400,
  sqmPrice: 10,
  priceRange: [950, 2400],
  priceByStatus: {
    price_6: 1600,
    price_1: 1457,
    price_2: 1200,
    price_5: 900,
  },
  yieldRental: {
    neighborhood: 4.5,
    district: 4.9,
    municipality: 6.4,
  },
};

const mockSaleProfile: SaleProfile = {
  bestMethod: 'ECO',
  mainValue: 561933,
  estimatedMin: 500000,
  estimatedMax: 620000,
  sqmPrice: 5619,
  priceRange: null,
  priceByStatus: null,
  timeOnMarket: 8,
  negotiationLeeway: 10,
};

export const mockValuationData: ValuationDataModel = {
  excludeRent: false,
  excludeSale: false,
  reportOperation: 0,
  reportType: 2,
  listingType: 1,
  rent: mockRentProfile,
  sale: mockSaleProfile,
  rentValuationFailed: false,
  saleValuationFailed: false,
  yieldParam: 4.5,
};

export const mockAssetProfileData: AssetProfileDataModel = {
  lat: mockAssetDetails.lat,
  lon: mockAssetDetails.lon,
  address: mockAssetDetails.address,
  listingType: mockAssetDetails.listingType,
  propertyType: mockAssetDetails.propertyType ?? 4,
  area: mockAssetDetails.area,
  parcelArea: mockAssetDetails.parcelArea ?? null,
  floor: mockAssetDetails.floor ?? 2,
  rooms: mockAssetDetails.rooms ?? 3,
  nbaths: mockAssetDetails.nbaths ?? 2,
  yearBuilt: mockAssetDetails.yearBuilt ?? 2010,
  buildStatus: mockAssetDetails.buildStatus ?? 1,
  features: {},
  neighborhood: 'Centro',
  district: 'Centro',
  city: 'Madrid',
  cadastralRef: null,
  reportType: mockAssetDetails.reportType,
};
